<template>
  <div class="class-1">
    <AppHeader title="Category" />
    <button class="add-category-btn" @click="addNewCategory">Add New Category</button>

    <table id="categoryTable">
      <thead>
        <tr>
          <!-- <th>Num.</th> -->
          <th></th>
          <th v-for="lang in languages" :key="lang.id">Name in {{ lang.fullName }}</th>
          <!-- <th>Parent ID</th> -->
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <!-- Top-level categories -->
        <template v-for="category in filteredTopLevelCategories" :key="'parent-' + category.id">
          <CategoryRow 
            :category="category"
            :languages="languages"
            :all-categories="categories"
            :expanded-categories="expandedCategories"
            @toggle-children="toggleChildren"
            @handle-menu="handleMenu"
            @handle-update="handleUpdate"
            @handle-suspend="handleSuspend"
            @handle-delete="handleDelete"
            :depth="0"
          />
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';
import { h } from 'vue';
// import suspendIcon from '@/assets/suspend_icon.png';
// Recursive component for rendering categories
const CategoryRow = {
  name: 'CategoryRow',
  props: {
    category: Object,
    languages: Array,
    allCategories: Array,
    expandedCategories: Array,
    depth: Number
  },
  methods: {
    hasChildren(categoryId) {
      return this.allCategories.some(cat => cat.parentId === categoryId);
    },
    getChildren(parentId) {
      return this.allCategories.filter(cat => cat.parentId === parentId);
    },
    getCategoryNameForLanguage(category, langId) {
      if (category.languages && category.languages.length > 0) {
        const langName = category.languages.find(l => l.langId === langId);
        return langName ? langName.name : 'N/A';
      }
      return "N/A";
    }
  },
  render() {
    const children = [];
    
    // Current category row
    children.push(
      h('tr', {
        class: { 
          'parent-row': this.hasChildren(this.category.id), 
          'group-row': this.category.isGroup === 1,
          'child-row': this.depth > 0,
        },
        style:{
'background-color': this.depth > 0 
    ? 'color-mix(in srgb, var(--bg-color) 80%, black)' 
    : '',
    'box-shadow': this.depth > 0 
    ? 'inset 0 0 1px 1px var(--font-color)' 
    : '',
     'border-radius': this.depth > 0 
    ? '0 0 5px 5px' 
    : '',
  }
        
      }, [
        h('td', [
  this.hasChildren(this.category.id) && 
  h('span', {
    class: 'toggle-children',
    style: {
      color: !this.expandedCategories.includes(this.category.id) ? 'inherit' : 'green',
      cursor: 'pointer'
    },
    onClick: () => this.$emit('toggle-children', this.category.id)
  }, this.expandedCategories.includes(this.category.id) ? '▼' : '▶'),
  // this.category.id
]),
        ...this.languages.map(lang => 
          h('td', this.getCategoryNameForLanguage(this.category, lang.id))
        ),
        // h('td', this.category.parentId || 'N/A'),
        h('td', this.category.isSuspend ? 'Suspended' : 'Active'),
        h('td', { class: 'action-buttons' }, [
          this.category.isGroup != 1 && h('button', {
            'data-tooltip': 'Menu',
            onClick: () => this.$emit('handle-menu', this.category)
          }, h('img', {
            src: require('@/assets/menu_icon.png'),
            alt: 'Menu'
          })),
          h('button', {
            'data-tooltip': 'Update',
            onClick: () => this.$emit('handle-update', this.category)
          }, h('img', {
            src:  require('@/assets/edit_icon.png') ,
            alt: 'Update'
          })),
          // h('button', {
          //   'data-tooltip': 'Suspend',
          //   onClick: () => this.$emit('handle-suspend', this.category)
          // }, h('img', {
          //   src: suspendIcon,
          //   alt: 'Suspend'
          // })),
          h('button', {
            'data-tooltip': 'Delete',
            onClick: () => this.$emit('handle-delete', this.category)
          }, h('img', {
            src: require('@/assets/delete_icon.png'),
            alt: 'Delete'
          }))
        ])
      ])
    );

    // Recursive rendering of children
    if (this.expandedCategories.includes(this.category.id) && this.hasChildren(this.category.id)) {
      this.getChildren(this.category.id).forEach(child => {
        children.push(
          h(CategoryRow, {
            category: child,
            languages: this.languages,
            'all-categories': this.allCategories,
            'expanded-categories': this.expandedCategories,
            onToggleChildren: (id) => this.$emit('toggle-children', id),
            onHandleMenu: (cat) => this.$emit('handle-menu', cat),
            onHandleUpdate: (cat) => this.$emit('handle-update', cat),
            onHandleSuspend: (cat) => this.$emit('handle-suspend', cat),
            onHandleDelete: (cat) => this.$emit('handle-delete', cat),
            depth: this.depth + 1,
            key: `child-${child.id}`
          })
        );
      });
    }

    return children;
  }
};

export default {
  components: {
    CategoryRow
  },
  data() {
    return {
      categories: [], 
      languages: [],
      currentDate: "",
      currentTime: "",
      token: null,
      expandedCategories: [],
    };
  },
  computed: {
    topLevelCategories() {
      return this.categories.filter(category => 
        !category.parentId || category.isGroup === 1
      );
    },
    filteredTopLevelCategories() {
      return this.categories.filter(category => {
        const isTopLevel = !category.parentId || !this.hasParent(category.parentId);
        const isGroupTopLevel = category.isGroup === 1 && isTopLevel;
        return isTopLevel || isGroupTopLevel;
      });
    }
  },
  methods: {
    hasParent(parentId) {
      return this.categories.some(cat => cat.id === parentId);
    },
    toggleChildren(categoryId) {
      const index = this.expandedCategories.indexOf(categoryId);
      if (index === -1) {
        this.expandedCategories.push(categoryId);
      } else {
        this.expandedCategories.splice(index, 1);
      }
    },
    getCategoryNameForLanguage(category, langId) {
      if (category.languages && category.languages.length > 0) {
        const langName = category.languages.find(l => l.langId === langId);
        return langName ? langName.name : 'N/A';
      }
      return "N/A";
    },
    getCategoryName(category) {
      return this.getCategoryNameForLanguage(category, this.languages[0]?.id) || 'N/A';
    },
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    addNewCategory() {
      if (!this.$hasPermission('create categories')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ 
        name: "AddCatComponent", 
        params: { languages: this.languages } 
      });
    },
    handleMenu(category) {
      if (!this.$hasPermission('view products')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ name: "CatProductsComponent", params: { id: category.id } });
    },
    handleUpdate(category) {
      if (!this.$hasPermission('edit categories')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ name: "EditCategoryComponent", params: { id: category.id } });
    },
    handleSuspend(category) {
      alert(`Suspend clicked for: ${this.getCategoryName(category)}`);
    },
      hasChildren(categoryId) {
    return this.categories.some(cat => cat.parentId === categoryId);
  },
    async handleDelete(category) {
      if (!this.$hasPermission('delete categories')){
        this.$toast.error('Not Permitted');
        return;
    }
      const categoryName = this.getCategoryName(category);
      
      if (this.hasChildren(category.id)) {
        this.$toast.error(`Cannot delete "${categoryName}" because it has sub-categories. Delete sub-categories first.`);
        return;
      }
      
      try {
        this.$root.isLoading = true; 
        const productsResponse = await axios.get(
          `${this.$BASE_API_URL}/api/products?catId=${category.id}`,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        
        if (productsResponse.data.data?.length > 0) {
          this.$toast.error(`Cannot delete "${categoryName}" because it contains products. Remove products first.`);
          return;
        }
      } catch (error) {
        console.error('Error checking products:', error);
        this.$toast.error('Error verifying category contents. Please try again.');
        return;
      } finally {
        this.$root.isLoading = false;
      }

      if (!confirm(`Are you sure you want to permanently delete "${categoryName}"?`)) {
        return;
      }

      try {
        this.$root.isLoading = true; 
        const response = await axios.delete(
          `${this.$BASE_API_URL}/api/categories/${category.id}`,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );

        if (response.status >= 200 && response.status < 300) {
          this.$toast.success(`"${categoryName}" deleted successfully!`);
          this.fetchCategories(); 
        } else {
          throw new Error(response.data.message || 'Deletion failed');
        }
      } catch (error) {
        console.error('Deletion error:', error);
        this.$toast.error(
          error.response?.data?.message || 
          'Failed to delete category. Please try again.'
        );
      } finally {
        this.$root.isLoading = false;
      }
    },
  async fetchCategories() {
  try {
    this.$root.isLoading = true;
    const branchId = localStorage.getItem('branchId');
    
    const response = await axios.get(`${this.$BASE_API_URL}/api/categories`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      params: {
        branchId: branchId 
      }
    });
    
    if (response.data.status) {
      this.categories = response.data.data; 
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    this.$root.isLoading = false;
  }
},
  },
  mounted() {
    this.token = localStorage.getItem('authToken'); 
    this.updateDateTime(); 
    setInterval(this.updateDateTime, 1000); 
    this.fetchCategories();
    const storedLanguages = localStorage.getItem('languages');
    if (storedLanguages) {
      try {
        this.languages = JSON.parse(storedLanguages).reverse();
      } catch (e) {
        console.error('Error parsing languages from localStorage:', e);
      }
    }
  }
};
</script>

<style scoped>
th,
td {
  border: 1px solid;
  padding: 8px;
  text-align: left;
}
tr.child-row{
  background-color: var(--font-color)* 0.8;
}
.child-row{
  background-color: var(--font-color) * 0.8;
}
.add-category-btn {
  float: right;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  width: max-content;
  border-radius: 5px;
  margin-top: .5rem;
  margin-right: .5rem;
}
.action-buttons button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.action-buttons button:hover {
  transform: scale(1.2); 
  opacity: 0.8; 
}
.action-buttons button:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}
.action-buttons button img {
  width: 20px;
  height: 20px;
}

/* .parent-row {
  background-color: #f5f5f5;
  font-weight: bold;
} */
.toggle-children {
  cursor: pointer;
  display: inline-block;
  width: 20px;
  text-align: center;
  margin-right: 5px;
}
.child-row td:first-child {
  padding-left: 30px;
}
.parent-row:hover, .child-row:hover {
  /* background-color: #e9e9e9; */
}

  th,
  td {
    border: 1px solid;
    padding: 8px;
    text-align: left;
  }
  .add-category-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: .5rem;
  }
  .action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.2); 
    opacity: 0.8; 
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }

  </style>